module.exports = __webpack_public_path__ + "static/Customize-Banners-1-e1403554318710-5136974ae6f195f56528aeaffa0bc2e6.jpg";